import React from 'react'
import './SecondCard.css'
const SecondCard = (imglink) => {
  return (
    <div  className='mycard' >
    <img src={imglink.li}/>

    </div>
  )
}

export default SecondCard